
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getConfigNodesMap: 'getConfigNodesMap',
      getDarkMode: 'getDarkMode',
      getTopLevelNodeNameReferenceIDsMap: 'getTopLevelNodeNameReferenceIDsMap',
    }),
  },
  methods: {
    ...mapActions({
      setSnackBarText: 'setSnackBarText',
      setSelectedNodeViaID: 'setSelectedNodeViaID',
    }),
  },
})
export default class TableView extends Vue {
  @Prop(String) treeRef!: String
  @Prop(Array) items!: Array<Object>
  @Prop(String) treeType!: string
  @Prop(String) search!: String
  //private search: string = ''

  private headers: Array<Object> = [
    {
      align: 'start',
      sortable: false,
      value: 'name',
      filterable: true,
    },
  ]

  //Vuex getters
  private getConfigNodesMap!: Object

  //Vuex actions
  private setSelectedNodeViaID!: (payload: {
    selectedNodeId: number
    forceOpenNode: boolean
  }) => Promise<any>

  // eslint-disable-next-line no-unused-vars
  public filterByModuleName(value, search, item) {
    return item.name.indexOf(search) !== -1
  }

  public checkIfNodeIsParamType(itemType: string): boolean {
    if (
      itemType.indexOf('cms.') != -1 ||
      itemType == 'string' ||
      itemType == 'int32' ||
      itemType == 'double' ||
      itemType == 'VPSet' ||
      itemType == 'PSet' ||
      itemType == 'untracked.PSet' ||
      itemType == 'untracked.VPSet' ||
      itemType == 'InputTag'
    )
      return true
    else return false
  }

  async fetchNodeById(itemId: number): Promise<void> {
    /*  console.log('ITEM ID: ' + itemId)
    console.log('NODE: ' + JSON.stringify(this.getConfigNodesMap[itemId])) */
    if (
      this.getConfigNodesMap[itemId] == undefined ||
      this.checkIfNodeIsParamType(this.getConfigNodesMap[itemId].type) //don't fetch params
    )
      return
    /*    console.log(
      'this.getConfigNodesMap[itemId].type:' +
        this.getConfigNodesMap[itemId].type
    ) */
    /*     console.log(
      'this.getConfigNodesMap[itemId].children: ' +
        this.getConfigNodesMap[itemId].children
    ) */
    //console.log('fetchNodeById CALLED')
    //console.log('ITEM ID: ' + itemId)
    if (this.getConfigNodesMap[itemId].rootNodeId != itemId) {
      itemId = this.getConfigNodesMap[itemId].rootNodeId
      //console.log('ROOT NODE ID: ' + itemId)

      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
    } else
      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
  }
}
